export default __webpack_public_path__ + "07da5cdde123277992841621b39454b1.svg";